"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuperAdmin = exports.isAdmin = exports.ForumBrandUpdateSchema = exports.MemberReportSchema = exports.UserSearchDTO = exports.UserSearchDTOSchema = exports.UserRequestDTOSchema = exports.UserDTO = exports.UserDTOSchema = exports.UserSchema = exports.UserBaseSchema = exports.SSTRole = exports.UserRole = exports.CurrentMembershipDTOSchema = exports.CurrentMembershipSchema = void 0;
var zod_1 = require("zod");
var Billing_1 = require("./Billing");
var Comment_1 = require("./Comment");
var Follow_1 = require("./Follow");
var GeneralSettings_1 = require("./GeneralSettings");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var Like_1 = require("./Like");
var MembershipStatus_1 = require("./MembershipStatus");
var Message_1 = require("./Message");
var Notification_1 = require("./Notification");
var Post_1 = require("./Post");
var Professional_1 = require("./Professional");
exports.CurrentMembershipSchema = zod_1.z.object({
    membershipStatusId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    membershipRateId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    membershipType: zod_1.z.string(),
    membershipTypeSlug: zod_1.z.string().optional(),
    isPYAMember: zod_1.z.boolean(),
    forumsAccess: zod_1.z.boolean().default(false),
    status: zod_1.z.nativeEnum(MembershipStatus_1.MEMBERSHIP_STATUS),
    issueDate: zod_1.z.coerce.date(),
    expireDate: zod_1.z.coerce.date(),
    subscriptionId: zod_1.z.string().optional(),
    subscriptionStatus: zod_1.z.string().optional(),
    currentPeriodEnd: zod_1.z.coerce.date().optional(),
});
exports.CurrentMembershipDTOSchema = zod_1.z.object({
    membershipStatusId: zod_1.z.string(),
    membershipRateId: zod_1.z.string(),
    membershipType: zod_1.z.string(),
    membershipTypeSlug: zod_1.z.string().optional(),
    isPYAMember: zod_1.z.boolean(),
    forumsAccess: zod_1.z.boolean().default(false),
    status: zod_1.z.nativeEnum(MembershipStatus_1.MEMBERSHIP_STATUS),
    issueDate: zod_1.z.coerce.date(),
    expireDate: zod_1.z.coerce.date(),
    subscriptionId: zod_1.z.string().optional(),
    subscriptionStatus: zod_1.z.string().optional(),
    currentPeriodEnd: zod_1.z.coerce.date().optional(),
});
var UserRole;
(function (UserRole) {
    UserRole["Regular"] = "Regular";
    UserRole["Admin"] = "Admin";
    UserRole["SuperAdmin"] = "SuperAdmin";
    UserRole["API"] = "Api";
    UserRole["NonMember"] = "NonMember";
    UserRole["Partner"] = "Partner";
    UserRole["Honorary"] = "Honorary";
})(UserRole || (exports.UserRole = UserRole = {}));
var SSTRole;
(function (SSTRole) {
    SSTRole["All"] = "All";
    SSTRole["SRB_Officer"] = "SRBOfficer";
    SSTRole["Office_Admin"] = "OfficeAdmin";
})(SSTRole || (exports.SSTRole = SSTRole = {}));
exports.UserBaseSchema = zod_1.z.object({
    role: zod_1.z.nativeEnum(UserRole).default(UserRole.Regular),
    fullName: zod_1.z.string().trim().min(1),
    email: zod_1.z.string().trim().toLowerCase().email(),
    banned: zod_1.z.boolean().default(false),
    forumPostingRestricted: zod_1.z.boolean().default(false),
    forumGuidelinesAcceptedAt: zod_1.z.coerce.date().optional(),
    forumBusinessName: zod_1.z.string().trim().optional(),
    forumLogo: zod_1.z.string().optional(),
    forumLogoPublicId: zod_1.z.string().optional(),
    password: zod_1.z.string().trim().min(1),
    username: zod_1.z.string().trim().min(1).toLowerCase(),
    resetPasswordToken: zod_1.z.string().optional(),
    image: zod_1.z.string().optional(),
    imagePublicId: zod_1.z.string().optional(),
    dsrbThumbnailPublicId: zod_1.z.string().optional(), // 150x150 for avatars (small thumbnail)
    thumbnailLargePublicId: zod_1.z.string().optional(), // 300x300 for main profile (large thumbnail)
    about: zod_1.z.string().optional(),
    website: zod_1.z.string().optional(),
    coverImage: zod_1.z.string().optional(),
    coverImagePublicId: zod_1.z.string().optional(),
    isOnline: zod_1.z.boolean().default(false),
    posts: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    likes: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    comments: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    followers: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    following: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    notifications: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    messages: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    membershipStatus: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    generalSettings: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    professional: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    billing: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    previousLogin: zod_1.z.coerce.date().optional(),
    lastLogin: zod_1.z.coerce.date().optional(),
    verificationCode: zod_1.z.string().trim().length(6).optional(),
    verificationCodeExpiresAt: zod_1.z.coerce.date().optional(),
    isActive: zod_1.z.boolean(),
    membershipNumber: zod_1.z.string().optional(),
    sstRole: zod_1.z.nativeEnum(SSTRole).optional(),
    deletedAt: zod_1.z.coerce.date().optional(),
    /** Frozen at soft-delete time (deletedAt + retention period then in effect). Never recomputed from the live retention setting, so it can't drift if that setting changes later. */
    scheduledHardDeleteDate: zod_1.z.coerce.date().optional(),
    currentMembership: exports.CurrentMembershipSchema.optional(),
});
exports.UserSchema = exports.UserBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.UserDTOSchema = exports.UserSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.UserDTO = {
    convertFromModel: function (model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            role: model.role,
            fullName: model.fullName,
            email: model.email,
            banned: model.banned,
            forumPostingRestricted: model.forumPostingRestricted === true,
            forumGuidelinesAcceptedAt: model.forumGuidelinesAcceptedAt,
            forumBusinessName: model.forumBusinessName,
            forumLogo: model.forumLogo,
            forumLogoPublicId: model.forumLogoPublicId,
            username: model.username,
            // I don't think we should expose this one.
            // resetPasswordToken: model.resetPasswordToken,
            image: model.image,
            imagePublicId: model.imagePublicId,
            dsrbThumbnailPublicId: model.dsrbThumbnailPublicId,
            thumbnailLargePublicId: model.thumbnailLargePublicId,
            about: model.about,
            website: model.website,
            coverImage: model.coverImage,
            coverImagePublicId: model.coverImagePublicId,
            isOnline: model.isOnline,
            isActive: model.isActive,
            membershipNumber: model.membershipNumber,
            deletedAt: model.deletedAt,
            scheduledHardDeleteDate: model.scheduledHardDeleteDate,
            posts: (0, ObjectId_1.isArrayPopulated)(model.posts)
                ? model.posts.map(function (post) { return Post_1.PostDTO.convertFromModel(post); })
                : (_a = model.posts) === null || _a === void 0 ? void 0 : _a.map(function (post) { return post.toString(); }),
            likes: (0, ObjectId_1.isArrayPopulated)(model.likes)
                ? model.likes.map(function (like) { return Like_1.LikeDTO.convertFromModel(like); })
                : (_b = model.likes) === null || _b === void 0 ? void 0 : _b.map(function (like) { return like.toString(); }),
            comments: (0, ObjectId_1.isArrayPopulated)(model.comments)
                ? model.comments.map(function (comment) { return Comment_1.CommentDTO.convertFromModel(comment); })
                : (_c = model.comments) === null || _c === void 0 ? void 0 : _c.map(function (comment) { return comment.toString(); }),
            followers: (0, ObjectId_1.isArrayPopulated)(model.followers)
                ? model.followers.map(function (follower) { return Follow_1.FollowDTO.convertFromModel(follower); })
                : (_d = model.followers) === null || _d === void 0 ? void 0 : _d.map(function (follower) { return follower.toString(); }),
            following: (0, ObjectId_1.isArrayPopulated)(model.following)
                ? model.following.map(function (follow) { return Follow_1.FollowDTO.convertFromModel(follow); })
                : (_e = model.following) === null || _e === void 0 ? void 0 : _e.map(function (follow) { return follow.toString(); }),
            notifications: (0, ObjectId_1.isArrayPopulated)(model.notifications)
                ? model.notifications.map(function (notification) { return Notification_1.NotificationDTO.convertFromModel(notification); })
                : (_f = model.notifications) === null || _f === void 0 ? void 0 : _f.map(function (notification) { return notification.toString(); }),
            messages: (0, ObjectId_1.isArrayPopulated)(model.messages)
                ? model.messages.map(function (message) { return Message_1.MessageDTO.convertFromModel(message); })
                : (_g = model.messages) === null || _g === void 0 ? void 0 : _g.map(function (message) { return message.toString(); }),
            membershipStatus: (0, ObjectId_1.isArrayPopulated)(model.membershipStatus)
                ? model.membershipStatus.map(function (membershipStatus) {
                    return MembershipStatus_1.MembershipStatusDTO.convertFromModel(membershipStatus);
                })
                : (_h = model.membershipStatus) === null || _h === void 0 ? void 0 : _h.map(function (membershipStatus) { return membershipStatus.toString(); }),
            generalSettings: (0, ObjectId_1.isPopulated)(model.generalSettings)
                ? GeneralSettings_1.GeneralSettingsDTO.convertFromModel(model.generalSettings)
                : (_j = model.generalSettings) === null || _j === void 0 ? void 0 : _j.toString(),
            professional: (0, ObjectId_1.isPopulated)(model.professional)
                ? Professional_1.ProfessionalDTO.convertFromModel(model.professional)
                : (_k = model.professional) === null || _k === void 0 ? void 0 : _k.toString(),
            billing: (0, ObjectId_1.isPopulated)(model.billing)
                ? Billing_1.BillingDTO.convertFromModel(model.billing)
                : (_l = model.billing) === null || _l === void 0 ? void 0 : _l.toString(),
            lastLogin: model.lastLogin,
            verificationCode: model.verificationCode,
            verificationCodeExpiresAt: model.verificationCodeExpiresAt,
            sstRole: model.sstRole,
            currentMembership: model.currentMembership
                ? {
                    membershipStatusId: model.currentMembership.membershipStatusId.toString(),
                    membershipRateId: model.currentMembership.membershipRateId.toString(),
                    membershipType: model.currentMembership.membershipType,
                    membershipTypeSlug: model.currentMembership.membershipTypeSlug,
                    isPYAMember: model.currentMembership.isPYAMember,
                    forumsAccess: model.currentMembership.forumsAccess === true,
                    status: model.currentMembership.status,
                    issueDate: model.currentMembership.issueDate,
                    expireDate: model.currentMembership.expireDate,
                    subscriptionId: model.currentMembership.subscriptionId,
                    subscriptionStatus: model.currentMembership.subscriptionStatus,
                    currentPeriodEnd: model.currentMembership.currentPeriodEnd,
                }
                : undefined,
        };
        return dto;
    },
};
exports.UserRequestDTOSchema = exports.UserDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { role: exports.UserDTOSchema.shape.role.optional(), banned: exports.UserDTOSchema.shape.banned.optional(), isOnline: exports.UserDTOSchema.shape.isOnline.optional(), posts: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid like id')).optional(), likes: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid like id')).optional(), comments: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid comment id')).optional(), followers: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid follower id')).optional(), following: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid following id')).optional(), notifications: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid notification id')).optional(), messages: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid message id')).optional(), membershipStatus: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid membership status id')).optional(), generalSettings: (0, ObjectId_1.ObjectIdString)('Invalid general settings id'), professional: (0, ObjectId_1.ObjectIdString)('Invalid professional id'), billing: (0, ObjectId_1.ObjectIdString)('Invalid billing id') }));
exports.UserSearchDTOSchema = zod_1.z.object({
    image: zod_1.z.string().optional(),
    imagePublicId: zod_1.z.string().optional(),
    dsrbThumbnailPublicId: zod_1.z.string().optional(),
    thumbnailLargePublicId: zod_1.z.string().optional(),
    fullName: zod_1.z.string(),
    _id: zod_1.z.string(),
});
exports.UserSearchDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            fullName: model.fullName,
            image: model.image,
            imagePublicId: model.imagePublicId,
            dsrbThumbnailPublicId: model.dsrbThumbnailPublicId,
            thumbnailLargePublicId: model.thumbnailLargePublicId,
        };
        return dto;
    },
};
exports.MemberReportSchema = zod_1.z.object({
    UserId: zod_1.z.string(),
    MembershipNumber: zod_1.z.string(),
    fullName: zod_1.z.string(),
    lastLogin: zod_1.z.coerce.date(),
    email: zod_1.z.string(),
    RenewalDate: zod_1.z.coerce.date(),
    Type: zod_1.z.string(),
    Status: zod_1.z.string(),
});
exports.ForumBrandUpdateSchema = zod_1.z.object({
    forumBusinessName: zod_1.z.string().trim().max(120),
});
var isAdmin = function (userRole) {
    var isAdmin = userRole === UserRole.Admin;
    var isSuperAdmin = userRole === UserRole.SuperAdmin;
    return isAdmin || isSuperAdmin;
};
exports.isAdmin = isAdmin;
var isSuperAdmin = function (userRole) {
    return userRole === UserRole.SuperAdmin;
};
exports.isSuperAdmin = isSuperAdmin;
//# sourceMappingURL=User.js.map